import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AppointmentRequest } from '../../../services/rest-api.service';

@Component({
  selector: 'app-appointment-change',
  templateUrl: './appointment-change.component.html'
})
export class AppointmentChangeComponent implements OnInit {
  @Input() title;
  @Input() appointmentRequest: AppointmentRequest;
  errorMessage?: string;

  constructor(public modal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

  submitRequest() {
    if (!this.appointmentRequest.message
      || this.appointmentRequest.message.trim().length === 0) {
      this.errorMessage = "Message is required";
      return;
    }
    this.modal.close(this.appointmentRequest);
  }
}
